import React from "react";
import { Box, CircularProgress, Skeleton, Typography } from "@mui/material";
import { trustBudTokens } from "../../theme/tokens";
import trustBudMark from "../../assets/logo/trustbud-mark.png";

export default function LoadingState({
  title = "Preparing your view",
  body = "Pulling the latest TrustBud context into place.",
  rows = 3,
  steps = ["Your data", "Updates", "Next step"],
  compact = false,
  sx = {},
}) {
  const visibleSteps = Array.isArray(steps) ? steps.slice(0, 3) : [];

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid rgba(215, 226, 238, 0.94)",
        background: "linear-gradient(180deg, #f8fbff 0%, #ffffff 100%)",
        boxShadow: compact ? "none" : "0 14px 34px rgba(15, 23, 42, 0.05)",
        px: compact ? 1.8 : 2.4,
        py: compact ? 1.7 : 2.4,
        display: "grid",
        gap: 1.5,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
        <Box
          sx={{
            width: compact ? 54 : 66,
            height: compact ? 54 : 66,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            backgroundColor: "#f3f8ff",
            color: trustBudTokens.colors.brand.navy700,
            flexShrink: 0,
            border: "1px solid rgba(124, 200, 255, 0.34)",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: compact ? 38 : 48,
              height: compact ? 38 : 48,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              backgroundColor: "#ffffff",
              border: "1px solid rgba(124, 200, 255, 0.34)",
            }}
          >
            <Box
              component="img"
              src={trustBudMark}
              alt=""
              sx={{ width: compact ? 27 : 34, height: compact ? 27 : 34, objectFit: "contain" }}
            />
          </Box>
          <Box
            sx={{
              position: "absolute",
              right: -2,
              bottom: -2,
              width: compact ? 24 : 30,
              height: compact ? 24 : 30,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              backgroundColor: "#ffffff",
              border: "1px solid rgba(215, 226, 238, 0.94)",
            }}
          >
            <CircularProgress size={compact ? 13 : 16} sx={{ color: trustBudTokens.colors.brand.navy600 }} />
          </Box>
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 11.5, fontWeight: 950, color: trustBudTokens.colors.brand.navy600, textTransform: "uppercase", letterSpacing: 0.6 }}>
            TrustBud
          </Typography>
          <Typography sx={{ mt: 0.25, fontSize: compact ? "1rem" : "1.12rem", fontWeight: 850, color: "#13233d" }}>
            {title}
          </Typography>
          <Typography sx={{ mt: 0.35, fontSize: "0.92rem", color: "#60738c", lineHeight: 1.45 }}>
            {body}
          </Typography>
        </Box>
      </Box>

      {visibleSteps.length ? (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" }, gap: 0.75 }}>
          {visibleSteps.map((step) => (
            <Box
              key={step}
              sx={{
                minHeight: 36,
              borderRadius: "8px",
                border: "1px solid rgba(124, 200, 255, 0.25)",
                backgroundColor: "#eef7ff",
                display: "flex",
                alignItems: "center",
                gap: 0.55,
                px: 0.9,
              }}
            >
              <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: trustBudTokens.colors.brand.navy600 }} />
              <Typography sx={{ fontSize: "0.78rem", color: "#315676", fontWeight: 850, lineHeight: 1.25 }}>
                {step}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : null}

      <Box sx={{ display: "grid", gap: 0.8 }}>
        {Array.from({ length: rows }).map((_, index) => (
          <Box key={index} sx={{ display: "grid", gridTemplateColumns: "42px minmax(0, 1fr)", gap: 1, alignItems: "center" }}>
            <Skeleton variant="circular" width={34} height={34} />
            <Box>
              <Skeleton variant="text" width={`${72 - index * 8}%`} height={18} />
              <Skeleton variant="text" width={`${52 - index * 6}%`} height={14} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
